export class BrowserUtils {

  public static get isLocalhost(): boolean {
    return location.hostname === 'localhost';
  }

  public static get browser(): 'Chrome' | 'Firefox' | 'Safari' | 'Opera' | 'Edge' | 'Other' {
    const { userAgent } = navigator;

    if (userAgent.match(/chrome|chromium|crios/i)) {
      return 'Chrome';
    } else if (userAgent.match(/firefox|fxios/i)) {
      return 'Firefox';
    } else if (userAgent.match(/safari/i)) {
      return 'Safari';
    } else if (userAgent.match(/opr\//i)) {
      return 'Opera';
    } else if (userAgent.match(/edg/i)) {
      return 'Edge';
    } else {
      return 'Other';
    }
  }
}
